import { FetchableList } from "./fetchableLists";
import { MySelect } from "./mySelect";

export function MyDynamicSelect<T>({
  queryFn,
  queryKey,
  emptyChild,
  name,
  nameConstructor,
  valueContructor,

  value,
  isMultiple,
  placeholder,
  onChange,
}: {
  queryFn: Promise<T[] | null | undefined>;
  queryKey: any[];
  name: string;
  value: any;
  nameConstructor: (item: T) => string | null | undefined;
  valueContructor: (item: T) => string | null | undefined;
  emptyChild?: any;

  isMultiple?: boolean;
  placeholder?: string | null | undefined;
  onChange: (newValue: any, fullItem: any) => void;
}) {
  function getChild(data: T[] | null | undefined) {
    return (
      <MySelect
        options={[
          {
            value: "",
            label: placeholder || "Choisir...",
          },
          ...(data
            ?.filter((item) => item)
            .map((item: any) => {
              return {
                value: valueContructor(item),
                label: nameConstructor(item),
              };
            }) || []),
        ]}
        value={value}
        isMultiple={isMultiple || false}
        placeholder={placeholder}
        onChange={(newValue) => {
          let fullItem = (data?.find(
            (item: any) => valueContructor(item) == newValue
          ) || {}) as any;
          if (!newValue) {
            newValue = null;
            fullItem = null;
          }
          onChange?.(newValue, fullItem);
        }}
      ></MySelect>
    );
  }
  return (
    <div
      className="field"
      onClick={(e) => {
        e.stopPropagation();
      }}
    >
      <div className="label">{name}</div>
      <FetchableList
        queryKey={queryKey}
        queryFn={() => queryFn}
        emptyChild={emptyChild || getChild([])}
      >
        {(data) => getChild(data)}
      </FetchableList>
    </div>
  );
}
